import React, { useCallback } from 'react';
import { FormattedMessage as Translation } from 'react-intl';
import classNames from 'classnames';
import { getFormattedAmount } from "../../../Helpers/numbers";
var css = {
  "emiChoiceContainer": "oalp-3-EC-",
  "emiBtnContainer": "oalp-1UapB",
  "emiBtn": "oalp-3lSUr"
};
export var EMIChoicesContainer = function EMIChoicesContainer(_ref) {
  var repaymentPeriodCounts = _ref.repaymentPeriodCounts,
    currencySymbol = _ref.currencySymbol,
    selectedEMIChoice = _ref.selectedEMIChoice,
    selectEMIChoice = _ref.selectEMIChoice,
    locale = _ref.locale,
    cssClasses = _ref.cssClasses;
  var handleOnChange = useCallback(function (_, idx) {
    return function () {
      selectEMIChoice(idx);
    };
  }, [selectEMIChoice]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(css.emiChoiceContainer, cssClasses.containerClass)
  }, repaymentPeriodCounts.map(function (_ref2, idx) {
    var repaymentPeriodCount = _ref2.repaymentPeriodCount,
      emi = _ref2.emi;
    var monthsValues = {
      numberOfMonths: repaymentPeriodCount
    };
    return /*#__PURE__*/React.createElement("label", {
      htmlFor: "months".concat(repaymentPeriodCount),
      className: css.emiBtnContainer,
      key: "months".concat(repaymentPeriodCount)
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      id: "months".concat(repaymentPeriodCount),
      name: "emiValue",
      value: emi,
      hidden: true,
      onChange: handleOnChange(repaymentPeriodCount, idx),
      checked: idx === selectedEMIChoice
    }), /*#__PURE__*/React.createElement("div", {
      className: css.emiBtn
    }, /*#__PURE__*/React.createElement(Translation, {
      id: "monthsTxt",
      values: monthsValues
    }, function (txt) {
      return txt;
    }), /*#__PURE__*/React.createElement("span", null, getFormattedAmount(emi, currencySymbol, locale))));
  }));
};
export default EMIChoicesContainer;